import React from 'react'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import { CsHideIcon } from '../icons'
import { theme as deprecatedTheme } from '../../styled'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { css } from '@emotion/css'

interface Props {
  readonly onClick: () => void
  readonly show: boolean
  readonly bottomOffset: number
}

const transitionName = 'ContrastGrid_scrollToTop'
const transitionDuration = 300
const opacity = '0.8'
const bottomTransition = `bottom ${transitionDuration}ms`

interface ButtonProps {
  readonly onClick: () => void
  readonly bottomOffset: number
  readonly children: React.ReactNode
}

function Button({ bottomOffset, ...props }: ButtonProps) {
  return (
    <button
      className={css`
        display: flex;
        align-items: center;
        justify-content: center;
        border: 0;
        padding: 0;
        outline: 0;
        position: absolute;
        right: ${deprecatedTheme.space[3]}px;
        bottom: ${deprecatedTheme.space[2] + bottomOffset}px;
        background-color: ${theme.color.neutral100};
        color: ${theme.color.white};
        opacity: ${opacity};
        width: 36px;
        height: 28px;
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;

        transition: ${bottomTransition};

        &.${transitionName}-enter {
          opacity: 0.01;

          &.${transitionName}-enter-active {
            opacity: ${opacity};
            transition: opacity ${transitionDuration}ms ease-in,
              ${bottomTransition};
          }
        }

        &.${transitionName}-exit {
          opacity: ${opacity};

          &.${transitionName}-exit-active {
            opacity: 0.01;
            transition: opacity ${transitionDuration}ms ease-in,
              ${bottomTransition};
          }
        }
      `}
      {...props}
    />
  )
}

export function ScrollToTopButton(props: Props) {
  const { onClick, show, bottomOffset } = props

  return (
    <TransitionGroup>
      {show && (
        <CSSTransition classNames={transitionName} timeout={transitionDuration}>
          <Button
            bottomOffset={bottomOffset}
            key="scrollToTopButton"
            onClick={onClick}
          >
            <CsHideIcon height="1.5em" width="1.5em" />
          </Button>
        </CSSTransition>
      )}
    </TransitionGroup>
  )
}
